var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#DCEAFB",
    stroke: "#B6D4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.6667L25.0353 17.1493C25.1369 17.0986 25.2499 17.0746 25.3633 17.0797C25.4768 17.0848 25.5871 17.1188 25.6837 17.1785C25.7804 17.2382 25.8602 17.3216 25.9155 17.4208C25.9709 17.52 25.9999 17.6317 26 17.7453V22.2547C25.9999 22.3683 25.9709 22.48 25.9155 22.5792C25.8602 22.6783 25.7804 22.7618 25.6837 22.8215C25.5871 22.8812 25.4768 22.9152 25.3633 22.9203C25.2499 22.9254 25.1369 22.9014 25.0353 22.8507L22 21.3333V18.6667Z",
    stroke: "#1373E7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.3333C14 16.9797 14.1405 16.6406 14.3905 16.3905C14.6406 16.1405 14.9797 16 15.3333 16H20.6667C21.0203 16 21.3594 16.1405 21.6095 16.3905C21.8595 16.6406 22 16.9797 22 17.3333V22.6667C22 23.0203 21.8595 23.3594 21.6095 23.6095C21.3594 23.8595 21.0203 24 20.6667 24H15.3333C14.9797 24 14.6406 23.8595 14.3905 23.6095C14.1405 23.3594 14 23.0203 14 22.6667V17.3333Z",
    stroke: "#1373E7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoContent);
export default __webpack_public_path__ + "static/media/VideoContent.8d801b2b8d2ddc5beadacb17c1de6950.svg";
export { ForwardRef as ReactComponent };